import { render } from "./TheLogin.vue?vue&type=template&id=008b10b4"
import script from "./TheLogin.vue?vue&type=script&lang=js"
export * from "./TheLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__